<template>
  <div>
    <div
      v-for="(value, valueIndex) in _value"
      :key="valueIndex"
    >
      {{$_getValue(value)}}
    </div>
  </div>
</template>

<script>
import S_multiLayer from "@/helpers/multiLayer.js";
export default {
  data: () => ({
    layers: [],
    conditions: [],
    requiredFieldState: [],
  }),
  methods: {
    async $_fetchData(){
      try {
        const url = this.getUrl
        ? `${this.getUrl}`
        :`${this.modelName}`
        const params = {}
        if (this.conditions) {
          this.conditions.forEach((condition) => {
            if (condition.value) {
              if (condition.type === 'array') {
                params[`${condition.key}`] = ''
                condition.value.forEach((value) => {
                  params[`${condition.key}`] += `${value.id},`
                })
              } else if (condition.type === 'number') {
                params[`${condition.key}`] = `${condition.value}`
              }
            }
          })
        }
        if (this.searching) {
          params.search = `${this.searching}`
        }
        const res = await this.$axios(url, {params})
        this.layers = this.$_setItems(res.data.data)
      } catch (error) {
        alert(error)
      }
    },
    $_setItems(datas) {
      const keys = {
        valueKey: this.valueKey,
        textKey: this.textKey,
        setLayersKey: 'layers',
      }
      if ( this.layersSetting) {
        keys.getLayersKey = this.layersSetting.requiredFieldKey
      } else {
        keys.getLayersKey = this.modelName
      }
      const layers = S_multiLayer.setItems(datas, keys)
      return layers
    },
    $_getValue(value) {
      let resultValue = ''
      resultValue = value[`${this.textKey}`]
      if (value.layers && value.layers.length > 0) {
        resultValue += `/${this.$_getText(value.layers)}`
      }
      return resultValue
    },
    $_getText(layers) {
      let resultValue = ''
      layers.forEach((layer) => {
        if (resultValue !== '') {
          resultValue += `,`
        }
        resultValue += layer[`${this.textKey}`]
        
      })
      let subValue = ''
      layers.forEach((layer) => {
        if (layer.layers && layer.layers.length > 0) {
          if (subValue !== '') {
            subValue += `,`
          }
          subValue += `${this.$_getText(layer.layers)}`
          
        }
      })
      if (subValue !== '') {
        resultValue += `/${subValue}`
      }
      return resultValue
    },
    $_getConditions() {
      const _conditions = [];
      const conditionKeys = this.conditionKeys;
      if (!conditionKeys) {
        return [];
      }
      conditionKeys.forEach((conditionKey) => {
        let _value = "";
        if (this.originData && this.originData[conditionKey.fieldName]) {
          _value = Array.isArray(this.originData[conditionKey.fieldName])
          ? this.originData[conditionKey.fieldName]
          :this.originData[conditionKey.fieldName][`${this.valueKey}`];
        } else {
          _value = null
        }
        _conditions.push({
          key: conditionKey.conditionName,
          value: _value,
          type: conditionKey.type,
        });
      });
      return _conditions;
    },
    $_getRequiredFieldState() {
      if (this.requiredField) {
        return this.originData[this.requiredField];
      } else {
        return null;
      }
    },
  },
  computed: {
    _value() {
      if (!this.value || !this.value.length || this.layers.length <= 0) {
        return []
      } else {
        let formatValues = []
        if (Array.isArray(this.value)) {
          const value = []
          this.value.forEach((_value) => {
            value.push(_value.id)
          })
          const rootLayers = S_multiLayer.getRootLayers(this.layers, value, this.valueKey)
          rootLayers.forEach((item) => {
            const formatValue = {
              [`${this.valueKey}`]: item[`${this.valueKey}`],
              [`${this.textKey}`]: item[`${this.textKey}`],
              root: true
            }
            if (this.requiredFieldState) {
              const requiredFieldState = []
              this.requiredFieldState.forEach((_requiredFieldState) => {
                requiredFieldState.push(_requiredFieldState.id)
              })
              const layers = S_multiLayer.constructLayers(item.layers, requiredFieldState, this.valueKey, this.textKey, true)
              if (layers.length > 0) {
                formatValue.layers =layers
              }
            } else {
              const layers = S_multiLayer.constructLayers(item.layers, value, this.valueKey, this.textKey, true)
              if (layers.length > 0) {
                formatValue.layers =layers
              }
            }
            formatValues.push(formatValue)
          })
        } else {
          const value = this.value.id
          const rootLayer = this.layers.find((layer) => layer[`${this.valueKey}`] === value)
          const formatValue = {
            [`${this.valueKey}`]: rootLayer[`${this.valueKey}`],
            [`${this.textKey}`]: rootLayer[`${this.textKey}`],
            root: true
          }
          if (this.requiredFieldState) {
            const requiredFieldState = []
            this.requiredFieldState.forEach((_requiredFieldState) => {
              requiredFieldState.push(_requiredFieldState.id)
            })
            const layers = S_multiLayer.constructLayers(rootLayer.layers, requiredFieldState, this.valueKey, this.textKey, true)
            if (layers.length > 0) {
              formatValue.layers = layers
            }
          } else {
            const layers = S_multiLayer.constructLayers(rootLayer.layers, value, this.valueKey, this.textKey, true)
            if (layers.length > 0) {
              formatValue.layers =layers
            }
          }
          formatValues.push(formatValue)
        }
        return formatValues
      }
    },
  },
  props: {
    modelName: {
      type: String,
      default: null,
    },
    value: {},
    layersSetting: {
      type: Object,
    },
    textKey: {
      type: String,
      default: 'name',
    },
    valueKey: {
      type: String,
      default: 'id',
    },
    requiredField: {
      type: String,
    },
    getUrl: {
      type: String,
    },
    conditionKeys: {
      type: Array,
    },
    originData: {
      type: Object
    }
  },
  async mounted() {
    this.conditions = this.$_getConditions()
    this.requiredFieldState = this.$_getRequiredFieldState()
    await this.$_fetchData();
  },
};
</script>